var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FormEdit, useFormioContext } from "@formio/react";
import { useLocation } from "wouter";
export const EditForm = ({ url, type, onSaveForm = () => { }, }) => {
    const [initialForm, setInitialForm] = useState();
    const setLocation = useLocation()[1];
    const name = type === "form" ? "Form" : "Resource";
    const { token } = useFormioContext();
    useEffect(() => {
        const fetchForm = () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(url, {
                headers: { "x-jwt-token": token },
            });
            if (!response.ok) {
                const message = yield response.text();
                console.log("Fetching form failed:", message);
                return;
            }
            const form = yield response.json();
            setInitialForm(form);
        });
        setInitialForm(undefined);
        fetchForm();
    }, [url, token]);
    return (_jsx("div", { className: "panel enter-data active", children: initialForm ? (_jsx(FormEdit, { onSaveForm: (form) => {
                setInitialForm(form);
                onSaveForm(form);
                setLocation("/edit");
            }, components: {
                SaveButtonContainer: ({ children }) => (_jsx("div", { className: "save-form-bar button-wrap", style: { justifyContent: "end" }, children: children })),
                SaveButton: ({ onClick }) => (_jsxs("button", { className: "button save-form", onClick: onClick, children: ["Save ", name] })),
            }, initialForm: initialForm })) : null }));
};
